import React from 'react';


function SectionTitle ({ title }) {
    return (
        <h1 className="mt-20 mb-12 font-black text-black dark:text-white text-2xl">{title}</h1>
    );
}

export default SectionTitle;